import { filter } from "lodash";
import moment from "moment";
import React, { useMemo } from "react";
import { useMembers } from "../../context/members";
import MemberAvatarImg from "../../context/members/MemberAvatarImg";
import { getMessageContentJsx } from "../../utils/messageToJsx";
import { Message } from "../../utils/types";
import Copy from "../Copy";

interface Props {
  message: Message;
  withDiscordHandle?: boolean;
}

const MessageComponent: React.FC<Props> = ({ message, withDiscordHandle }) => {
  const { members } = useMembers();

  const createdAt = useMemo(
    () => moment(message.created_at).utc().fromNow(),
    [message.created_at]
  );

  const member = useMemo(
    () =>
      filter(
        members,
        ({ uuid }) =>
          uuid === message.user_data?.uuid || uuid === message.user_uuid
      )[0],
    [members, message.user_data?.uuid, message.user_uuid]
  );

  const content = useMemo(
    () => getMessageContentJsx(message.message),
    [message.message]
  );

  return (
    <div className="flex space-x-3">
      <div className="flex-shrink-0">
        <MemberAvatarImg
          member={
            member ||
            message.user_data || {
              uuid: message.contact_uuid,
              name: message.contact_name
            }
          }
          sizeInPx={40}
        />
      </div>
      <div>
        <div className="text-sm">
          <span className="font-medium text-gray-900 dark:text-white mr-1">
            {member?.name ||
              message.user_data?.name ||
              message.contact_name ||
              "System"}
            {withDiscordHandle && (
              <Copy
                text={message.user_data?.provider_nickname || "System"}
                label="Discord handle"
                className="inline ml-1 h-4 w-4 text-gray-500"
              />
            )}
          </span>
          <span className="font-medium text-gray-500 mx-1">{createdAt}</span>
        </div>

        <div className="mt-1 text-sm text-gray-700 dark:text-white">
          <p>{content}</p>
        </div>
      </div>
    </div>
  );
};

export default MessageComponent;
